








































































import { collapseMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { AllGeeksSingleSelect, AllAchievementTypesSingleSelect } from '@/components';
import { AchievementType, GeekItem } from '@/models';
import { Actions } from '@/store';
import { ToastsService, resetModel } from '@/utils';
import { GrantAchievementForm } from '@/models/admin-panel';

export default mixins(collapseMixin).extend({
  name: 'AchievementsGrantTab',
  components: {
    AllAchievementTypesSingleSelect,
    AllGeeksSingleSelect,
  },
  data() {
    return {
      form: {
        geekId: null as unknown as string,
        achievementTypeId: null as unknown as string,
        reason: null as unknown as string,
      },
      loader: {
        isRequestPending: false,
      },
    };
  },
  async created(): Promise<void> {
    this.loader.isRequestPending = true;

    try {
      await this.$store.dispatch(Actions.achievements.fetchAllAchievements);
    } finally {
      this.loader.isRequestPending = false;
    }
  },
  methods: {
    updateSelectGeek(selectedGeek: GeekItem) {
      this.form.geekId = selectedGeek ? selectedGeek.id : (null as unknown as string);
    },
    updateSelectedAchievementType(selectedAchievementType: AchievementType) {
      this.form.achievementTypeId = selectedAchievementType ? selectedAchievementType.id : (null as unknown as string);
    },
    async grantAchievement() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      this.loader.isRequestPending = true;
      try {
        const grantData: GrantAchievementForm = {
          achievementTypeId: this.form.achievementTypeId,
          reason: this.form.reason,
        };

        await this.$store.dispatch(Actions.achievements.grantAchievement, { geekId: this.form.geekId, grantData });
        ToastsService.success(this.$t('admin-panel.achievements.tabs.grant.grant-added-toast') as string);
        this.resetModels();
        (this as any).$refs.geekSelect.clearSelected();
        (this as any).$refs.achievementSelect.clearSelected();
      } finally {
        this.loader.isRequestPending = false;
      }
    },
    resetModels() {
      this.form = resetModel(this.form);
      requestAnimationFrame(async () => await this.$validator.reset());
    },
  },
});
